import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import store from './state/store'
import i18n from './i18n'
import router from './router/index'
import Vuelidate from 'vuelidate'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import vco from "v-click-outside"
Vue.use(VueRouter)


import "@/design/index.scss";

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(vco)

Vue.config.productionTip = false

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  fallbackLocale: 'en',
  render: h => h(App)
}).$mount('#app')
